"use client";
import { IAccountAssets, IBlocks, IUserData } from "@/types";
import React, { useState } from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { Button } from "@/components/ui/button";
import {
    IconAdjustmentsHorizontal,
    IconArrowDown,
    IconArrowUp,
    IconDeviceFloppy,
    IconPlus,
    IconSettings2,
    IconTrash,
} from "@tabler/icons-react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { v4 as uuidv4 } from "uuid";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Separator } from "@/components/ui/separator";
import { Switch } from "@/components/ui/switch";
import Assets from "@/components/admin/assets";
interface Props {
    account: IUserData;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
    assets: IAccountAssets[];
    impersonate?: any;
}

export default function CarouselOptions({
    account,
    block,
    blockUpdate,
    update,
    assets,
    impersonate,
}: Props) {
    const [editPopover, setEditPopover] = React.useState(false);
    const [editPopoverOpen, setEditPopoverOpen] = React.useState<any>(null);
    const [dialog, setDialog] = React.useState(false);
    const [accordionOpen, setAccordionOpen] = React.useState<any>(null);
    const [images, setImages] = React.useState<any>(
        block.options?.images || []
    );
    React.useEffect(() => {
        if (block.options?.images) {
            setImages(block.options?.images);
        }
    }, [block.options?.images]);
    const moveImage = (index: number, direction: "up" | "down") => {
        const newImages = [...images];

        // Remove the image at the current index
        const [removed] = newImages.splice(index, 1);

        // Calculate the new index based on the direction
        let newIndex = direction === "up" ? index - 1 : index + 1;

        // Ensure newIndex is within valid bounds
        if (newIndex < 0) newIndex = 0;
        if (newIndex >= newImages.length) newIndex = newImages.length;

        // Insert the removed image at the new index
        newImages.splice(newIndex, 0, removed);

        // Update the state with the new array
        setImages(newImages);
        update({ ...block, options: { ...block.options, images: newImages } });
    };
    return (
        <CardSetting title={"Displayed Images"} noBorder>
            <div className="border-3 flex w-full flex-col gap-3 border-white">
                {/* <Accordion
                    type="single"
                    collapsible
                    value={accordionOpen}
                    onValueChange={setAccordionOpen}
                > */}
                <div className="relative flex w-full flex-col gap-2">
                    {images.map((image: any, index: number) => (
                        <div
                            className="flex w-full items-center gap-2 rounded-md border-2 p-1"
                            key={index}
                        >
                            <div className="flex flex-col gap-0.5">
                                <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => moveImage(index, "up")}
                                    disabled={index === 0}
                                >
                                    <IconArrowUp />
                                </Button>
                                <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => moveImage(index, "down")}
                                    disabled={index === images.length - 1}
                                >
                                    <IconArrowDown />
                                </Button>
                            </div>
                            {/* <AccordionItem
                                    value={image.id}
                                    className="w-full rounded-md border-2 bg-accent/50"
                                >
                                    <AccordionTrigger className="flex items-center gap-2 rounded-md px-2 hover:no-underline"> */}
                            <div className="flex w-full max-w-full items-center gap-1">
                                <img
                                    src={image.url}
                                    alt={image.alt}
                                    className="h-16 w-16 rounded-md object-cover py-1"
                                />
                                <div className="flex flex-col gap-1">
                                    <p className="line-clamp-1 text-xs font-semibold">
                                        {image.caption}
                                    </p>
                                    <p className="line-clamp-1 text-sm font-semibold text-muted-foreground">
                                        {image.link}
                                    </p>
                                </div>
                            </div>
                            {/* </AccordionTrigger>
                                    <AccordionContent className="flex flex-col gap-2 rounded-b-md px-2 py-2"> */}
                            <div className="flex shrink-0 items-center gap-2">
                                <div className="ml-auto flex items-center gap-3">
                                    <DropdownPopover
                                        key={index}
                                        block={block}
                                        setImages={setImages}
                                        index={index}
                                        images={images}
                                        image={image}
                                        update={update}
                                    />
                                    <Popover>
                                        <PopoverTrigger asChild>
                                            <Button
                                                className="text-error"
                                                variant="outline"
                                                size={"icon"}
                                            >
                                                <IconTrash />
                                            </Button>
                                        </PopoverTrigger>
                                        <PopoverContent className="flex flex-col gap-1 p-3 shadow-xl">
                                            Remove from carousel?
                                            <Button
                                                // className="text-error"
                                                // variant="outline"
                                                size={"icon"}
                                                onClick={() => {
                                                    setImages(
                                                        images.filter(
                                                            (_image: any) =>
                                                                _image.id !==
                                                                image.id
                                                        )
                                                    );
                                                    update({
                                                        ...block,
                                                        options: {
                                                            ...block.options,
                                                            images: images.filter(
                                                                (_image: any) =>
                                                                    _image.id !==
                                                                    image.id
                                                            ),
                                                        },
                                                    });
                                                }}
                                            >
                                                <IconTrash />
                                            </Button>
                                        </PopoverContent>
                                    </Popover>
                                </div>
                            </div>
                            {/* </AccordionContent>
                                </AccordionItem> */}
                        </div>
                    ))}
                </div>
                {/* </Accordion> */}
            </div>
            <Dialog open={dialog} onOpenChange={setDialog}>
                <DialogTrigger asChild>
                    <Button className="mt-2">
                        <IconPlus />
                    </Button>
                </DialogTrigger>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>Asset Gallery</DialogTitle>
                    </DialogHeader>
                    <Assets
                        _assets={assets}
                        update={(asset) => {
                            console.log("🚀 ~ asset:", asset);
                            const id = uuidv4();
                            setImages([
                                ...images,
                                {
                                    id: id,
                                    url: asset.url,
                                    alt: asset.title,
                                },
                            ]);
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    images: [
                                        ...images,
                                        {
                                            id: id,
                                            url: asset.url,
                                            alt: asset.title,
                                        },
                                    ],
                                },
                            });
                            setDialog(false);
                        }}
                        block={block}
                        account_id={account.id}
                        impersonate={impersonate}
                        account={account}
                    />
                </DialogContent>
            </Dialog>
            <Separator className="my-2" />
            <div className="flex flex-col gap-2">
                <div className="flex items-center justify-between">
                    <Label variant="toggle" className="mb-0 pb-0">
                        Auto scroll
                    </Label>
                    <Switch
                        onCheckedChange={(value) => {
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    autoplay: value,
                                    autoplay_delay:
                                        block.options?.autoplay_delay || 1000,
                                },
                            });
                        }}
                        value={block.options?.autoplay}
                    >
                        Autoplay
                    </Switch>
                </div>
                {block.options?.autoplay && (
                    <div>
                        <Slider
                            value={[block.options?.autoplay_delay || 1000]}
                            min={1000}
                            max={10000}
                            step={1000}
                            onValueChange={(value) => {
                                update({
                                    ...block,
                                    options: {
                                        ...block.options,
                                        autoplay_delay: value[0],
                                    },
                                });
                            }}
                            className="w-full"
                        />
                        <Label variant="toggle" className="mx-auto pt-1">
                            {block.options?.autoplay_delay / 1000 || 1} second
                            {block.options?.autoplay_delay !== 1000 && "s"}
                        </Label>
                    </div>
                )}
            </div>
        </CardSetting>
    );
}

function DropdownPopover({
    block,
    setImages,
    images,
    update,
    image,
    index,
}: {
    block: IBlocks;
    setImages: (value: any) => void;
    images: any;
    image: any;
    index: number;
    update: (value: IBlocks) => void;
}) {
    const [dialog, setDialog] = useState(false);
    return (
        <Popover key={index} open={dialog} onOpenChange={setDialog}>
            <PopoverTrigger asChild>
                <Button variant="outline" size={"icon"}>
                    <IconAdjustmentsHorizontal />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="flex flex-col gap-3 p-3 shadow-xl">
                <div>
                    <Input
                        className=" text-copy"
                        label="Image URL"
                        variant="card"
                        placeholder="Image URL"
                        value={image.link || ""}
                        onChange={(e) => {
                            setImages(
                                images.map((_image: any) => {
                                    if (_image.id == image.id) {
                                        _image.link = e.target.value;
                                    }
                                    return _image;
                                })
                            );
                        }}
                    />
                    <Label variant="subtoggle">Optional</Label>
                </div>
                <div>
                    <Input
                        className=" text-copy"
                        label="Image caption"
                        variant="card"
                        placeholder="Picture of a cat"
                        value={image.caption || ""}
                        onChange={(e) => {
                            setImages(
                                images.map((_image: any) => {
                                    if (_image.id == image.id) {
                                        _image.caption = e.target.value;
                                    }
                                    return _image;
                                })
                            );
                        }}
                    />
                    <Label variant="subtoggle">Optional </Label>
                </div>
                <Button
                    className={`ml-auto w-fit shrink-0 gap-1 ${images == block.options?.images ? "hidden" : ""}`}
                    onClick={() => {
                        setDialog(false);
                        update({
                            ...block,
                            options: {
                                ...block.options,
                                images: images,
                            },
                        });
                    }}
                >
                    <IconDeviceFloppy size={18} />
                    Save
                </Button>
            </PopoverContent>
        </Popover>
    );
}
